import React from 'react'

const Backend = ({ skills = [], title = 'Backend Developer' }) => {
  return (
    <div className="skills__content">
                <h3 className="skills__title">{title}</h3>

        <div className="skills__box">
            <div className="skills__group">
                {skills.map((skill) => (
                    <div className="skills__data" key={skill.name}>
                        <i className="bx bx-badge-check"></i>

                        <div>
                            <h3 className="skills__name">{skill.name}</h3>
                            <span className="skills__level">{skill.level}</span>
                        </div>
                    </div>
                ))}
            </div>

            
        </div>

    </div>
  )
}

export default Backend
